export interface MetricPill {
  id: string;
  label: string;
  value: number | string;
  /** Short plain-language definition for tooltip / title. */
  definition: string;
  testId?: string;
  /** Optional challenger comparison line. */
  vs?: string;
  vsTestId?: string;
}

export interface MetricPillGridProps {
  pills: MetricPill[];
  testId?: string;
  className?: string;
}

/** Four compact score pills with short definitions (title + visually hidden text). */
export function MetricPillGrid({
  pills,
  testId = "metric-pill-grid",
  className = "",
}: MetricPillGridProps) {
  return (
    <div
      className={`metric-pill-grid ${className}`.trim()}
      data-testid={testId}
      role="list"
      aria-label="Edit outcome"
    >
      {pills.map((p) => (
        <div
          key={p.id}
          className="metric-pill"
          role="listitem"
          data-metric={p.id}
          data-value={String(p.value)}
          title={p.definition}
        >
          <span className="score-label">{p.label}</span>
          <strong data-testid={p.testId} data-score-dim={p.id}>
            {p.value}
          </strong>
          <span className="metric-def sr-only">{p.definition}</span>
          <span className="metric-def-tip" aria-hidden>
            {p.definition}
          </span>
          {p.vs != null ? (
            <span
              className="muted dim-vs"
              data-testid={p.vsTestId}
              data-score-dim={`challenger-${p.id}`}
            >
              {p.vs}
            </span>
          ) : null}
        </div>
      ))}
    </div>
  );
}
